import React, { useMemo } from 'react';
import { useWindowDimensions, View } from 'react-native';
import RenderHtml from 'react-native-render-html';
import { useTheme } from '@ui-kitten/components';

import themeStyle from '../Theme/styles';

import { RectangleLoader } from './Loader';
import { textCategory } from './Reservation/constants';
import ResponsiveText from './ResponsiveText';

const ValueLoader = () => (
  <View>
    <View style={themeStyle.spacingBottom}>
      <RectangleLoader width={215} height={32.5} />
    </View>
    <View style={themeStyle.spacingBottom}>
      <View style={themeStyle.spacingBottom}>
        <RectangleLoader height={72} />
      </View>
      <View style={themeStyle.spacingBottom}>
        <RectangleLoader height={120} />
      </View>
      <RectangleLoader height={48} />
    </View>
  </View>
);

const ReservationCancellationPolicy = ({
  isLoading,
  value,
}: {
  isLoading?: boolean;
  value?: string;
}) => {
  const { width } = useWindowDimensions();
  const theme = useTheme();

  const themeTextColor = theme['text-basic-color'];

  const renderHtmlProps = useMemo(() => {
    if (!value) return {};
    return {
      source: { html: value },
      baseStyle: { color: themeTextColor || '#222B45' },
      tagsStyles: { p: { margin: 0 } },
    };
  }, [themeTextColor, value]);

  if (isLoading) return <ValueLoader />;
  else if (value && renderHtmlProps.source) {
    return (
      <View style={themeStyle.spacingBottom}>
        <RenderHtml
          contentWidth={width}
          baseStyle={renderHtmlProps.baseStyle}
          source={renderHtmlProps.source}
          tagsStyles={renderHtmlProps.tagsStyles}
        />
      </View>
    );
  }
  return (
    <View>
      <View style={themeStyle.spacingBottom}>
        <ResponsiveText category={textCategory.HEADING} style={themeStyle.bold}>
          Pre-payment Reservation Cancellation Policy
        </ResponsiveText>
      </View>
      <View style={themeStyle.spacingBottom}>
        <View style={themeStyle.spacingBottom}>
          <ResponsiveText category={textCategory.BODY}>
            Our reservations are considered
            <ResponsiveText
              category={textCategory.BODY}
              style={themeStyle.bold}
            >
              {' '}
              pre-paid, non-refundable{' '}
            </ResponsiveText>
            reservations that do not allow refunds or cancellations.
            <ResponsiveText
              category={textCategory.BODY}
              style={themeStyle.bold}
            >
              {' '}
              Full payment is required{' '}
            </ResponsiveText>
            at the time of booking to secure the reservation. For Ala Carte
            reservations this amount will be deducted off your final bill.
          </ResponsiveText>
        </View>
        <View style={themeStyle.spacingBottom}>
          <ResponsiveText category={textCategory.BODY}>
            <ResponsiveText
              category={textCategory.BODY}
              style={themeStyle.bold}
            >
              Modifications:{' '}
            </ResponsiveText>
            You may change your reservation date with at least
            <ResponsiveText
              category={textCategory.BODY}
              style={themeStyle.bold}
            >
              {' '}
              3 days advance notice{' '}
            </ResponsiveText>
            by messaging us on Instagram. To change your number of guests,
            please message us on Instagram and we'll do our best to accommodate
            you.
          </ResponsiveText>
        </View>
        <ResponsiveText category={textCategory.BODY}>
          <ResponsiveText category={textCategory.BODY} style={themeStyle.bold}>
            No Show:{' '}
          </ResponsiveText>
          Please note that our restaurant is very busy and as such we ask all
          our guests to manage their anticipated travel times. Unfortunately we
          can only hold tables that are reserved for
          <ResponsiveText category={textCategory.BODY} style={themeStyle.bold}>
            {' '}
            (Lunch - 15 minutes){' '}
          </ResponsiveText>
          <ResponsiveText category={textCategory.BODY} style={themeStyle.bold}>
            {' '}
            (Dinner - 30 minutes){' '}
          </ResponsiveText>
          - after which we will consider the reservation abandoned and will
          release the reservation
          <ResponsiveText category={textCategory.BODY} style={themeStyle.bold}>
            {' '}
            without refund.{' '}
          </ResponsiveText>
          If you are running late please ensure that you contact our team on our
          contact number to request an extension on your start time. Please note
          that we will try our best to accommodate you but we cannot guarantee
          that we will be able to seat you after the reserved time slot.
        </ResponsiveText>
      </View>
    </View>
  );
};

export default ReservationCancellationPolicy;
